import React from "react";

export interface EnrolledFactorProp {
  id: string;
  factorName: string;
  additionalInfo?: string;
}

const EnrolledFactorList = ({
  enrolledFactorList,
}: {
  enrolledFactorList: EnrolledFactorProp[];
}): React.JSX.Element => {
  return (
    <ul className="fe_u_font-size--small fe_u_margin--left-small fe_u_margin--top-small">
      {enrolledFactorList.map((enrolledFactor, _) => (
        <li
          className="uiam-enrolled-factor-detail-list-item fe_u_margin--bottom-xsmall"
          key={enrolledFactor.id}
        >
          <span className="fe_u_font-weight--semibold">
            {enrolledFactor.factorName + " "}
          </span>
          {enrolledFactor.additionalInfo}
        </li>
      ))}
    </ul>
  );
};

export default EnrolledFactorList;
